import { METER_POINT_ID_LENGTH } from "../constants/meterPointLength"

export function isMeterPointIdValid(value: string) {
    if (!value || value.length !== METER_POINT_ID_LENGTH || !/^[0-5,9][0-9]*$/.test(value)) {
        return false
    }

    const n1 =
        Number(value[3]) +
        Number(value[4]) +
        Number(value[5]) +
        Number(value[6]) +
        Number(value[7]) +
        Number(value[8]) +
        Number(value[9]) +
        Number(value[10]) +
        Number(value[11]) +
        2
    const n2 =
        2 +
        2 * Number(value[11]) +
        3 * Number(value[10]) +
        4 * Number(value[9]) +
        5 * Number(value[8]) +
        6 * Number(value[7]) +
        7 * Number(value[6]) +
        8 * Number(value[5]) +
        9 * Number(value[4]) +
        10 * Number(value[3])
    let mod1 = n1 % 11
    let mod2 = n2 % 11

    if (mod1 === 10 && mod2 === 10) {
        mod1 = 9
        mod2 = 9
    } else if (mod1 === 10 && mod2 === 0) {
        mod1 = 9
        mod2 = 8
    } else if (mod1 === 10 && mod2 !== 0) {
        mod1 = 0
    } else if (mod1 === 0 && mod2 === 10) {
        mod1 = 8
        mod2 = 9
    } else if (mod1 !== 0 && mod2 === 10) {
        mod2 = 0
    }

    return value[12] === mod1.toString() && value[13] === mod2.toString()
}
